import { Alert } from 'antd';
import type { WorkOrderApprovalReadiness } from '../work-orders.api';

/** Why a raised order cannot be approved yet. Quotes are recorded outside these screens for now, so the reasons are read-only here. */
export function ApprovalReadinessNote({ readiness }: { readiness: WorkOrderApprovalReadiness | null }) {
  if (readiness === null || readiness.isMet) return null;

  return (
    <Alert
      type="warning"
      showIcon
      title="This order can't be approved yet"
      description={
        <ul className="m-0 list-disc pl-5">
          {readiness.reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      }
    />
  );
}
